<div
    class="md:py-0 md:border-b-0"
    [class.min-h-12]="orientation() === 'horizontal'"
    [class.border-b]="orientation() === 'vertical' && !alwaysExpanded()"
    [class.border-gray-300]="orientation() === 'vertical' && !alwaysExpanded()"
    [class.pb-[10px]]="orientation() === 'vertical'"
    [class.flex]="orientation() === 'horizontal'"
    [class.items-center]="orientation() === 'horizontal'">
    <div
        class="flex md:hover:no-underline outline-offset-8"
        [class.md:mb-6]="orientation() === 'vertical'"
        [class.mb-6]="orientation() === 'vertical' && (isActive || alwaysExpanded())"
        [attr.role]="isMobile() && orientation() === 'vertical' && !alwaysExpanded() ? 'button' : null"
        [attr.tabindex]="isMobile() && orientation() === 'vertical' && !alwaysExpanded() ? 0 : -1"
        [attr.aria-expanded]="isActive && isMobile() && orientation() === 'vertical' && !alwaysExpanded() ? 'true' : null"
        (click)="isActive = !isActive"
        (keydown.enter)="isActive = !isActive"
        (keydown.space)="isActive = !isActive">
        @if (menu()?.label) {
            <h6
                class="mb-0 grow leading-[1.6]"
                [class]="headerClass()"
                [class.mr-5]="orientation() === 'horizontal'"
                [class.text-xl]="orientation() === 'vertical'">
                {{ menu()?.label }}
            </h6>
        }
        @if (orientation() === 'vertical') {
            <div
                class="flex items-center mb-px ml-auto transition-transform md:hidden"
                [class.hidden]="alwaysExpanded()">
                <big-icon
                    [icon]="isActive ? iconMinus : iconPlus"
                    [size]="'w-4'"
                    class="block fill-white" />
                @if (menu()?.label) {
                    <span class="sr-only">{{ menu()?.label }}</span>
                }
            </div>
        }
    </div>
    <div
        [class.hidden]="!isActive && orientation() === 'vertical' && !alwaysExpanded()"
        [class.md:block]="!isActive && orientation() === 'vertical' && !alwaysExpanded()"
        [class.mb-[10px]]="orientation() === 'vertical' && isActive && !alwaysExpanded()">
        <ul
            class="mb-0 flex gap-x-8 gap-y-[26px]"
            [class]="listClass()"
            [class.flex-col]="orientation() === 'vertical'"
            [class.gap-y-1]>
            @for (item of menu()?.items; track $index) {
                <li>
                    <big-ui-link
                        [href]="item.uri"
                        [linkClass]="`no-underline after:-inset-x-3 after:-inset-y-3 leading-[1.6] font-normal font-sans ${item.iconOnly ? 'icon' : 'outline-offset-8'}`">
                        <div class="flex items-center">
                            @if (item.icon && iconMap()) {
                                <big-icon
                                    [icon]="iconMap() | iconMapToIcon: item.icon"
                                    [size]="'w-6'"
                                    [inline]="true"
                                    [class.mr-2]="!item.iconOnly"
                                    class="align-middle fill-white" />
                            }
                            <span [ngClass]="{ 'sr-only': item.iconOnly }">
                                {{ item.title }}
                            </span>
                        </div>
                    </big-ui-link>
                </li>
            }
        </ul>
    </div>
</div>
